import API from './utils/API'

const api = new API()
const prefix = '/plan-intervention'

const getGroupByStandardMastery = (params = {}) =>
  api.callApi({
    url: `${prefix}/group-by-standard-mastery`,
    method: 'get',
    params,
  })

const getGroupByCategories = (params = {}) =>
  api.callApi({
    url: `${prefix}/group-by-categories`,
    method: 'get',
    params,
  })

export default {
  getGroupByStandardMastery,
  getGroupByCategories,
}
